export default __webpack_public_path__ + "static/media/overview_first_tile.b862ea9c.svg";